import type { IntlShape } from "react-intl";

export const defaultColumnConfig = {
  isDisabled: false,
  isChecked: true,
  isSortable: true,
};

export const createColumn = (
  key: string,
  label: string,
  width: string,
  overrides = {},
) => ({
  key,
  label,
  value: key,
  width,
  ...defaultColumnConfig,
  ...overrides,
});

export const getSortOptions = (intl: IntlShape) =>
  [
    {
      label: intl.formatMessage({
        defaultMessage: "Ascending",
        id: "3O5viX",
        description: "sort option: Ascending",
      }),
      value: "asc",
      icon: "ArrowUp",
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Descending",
        id: "L24fRI",
        description: "sort option: Descending",
      }),
      value: "desc",
      icon: "ArrowDown",
    },
  ].map((option) => ({
    ...option,
    isDisabled: false,
    isChecked: false,
  }));
